export const OTHER = 'Other'
export const ShippingProviders = [
  { key: 'UPS', value: 'UPS' },
  { key: 'USPS', value: 'USPS' },
  { key: 'FedEx', value: 'FedEx' },
  { key: 'DHL', value: 'DHL' },
  { key: OTHER, value: OTHER },
]